/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlannedLaborCostRequest } from '../../models/create-planned-labor-cost-request';
import { PlannedLaborCostDto } from '../../models/planned-labor-cost-dto';

export interface CreatePlannedLaborCost$Params {
      body: CreatePlannedLaborCostRequest
}

export function createPlannedLaborCost(http: HttpClient, rootUrl: string, params: CreatePlannedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedLaborCostDto>> {
  const rb = new RequestBuilder(rootUrl, createPlannedLaborCost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedLaborCostDto>;
    })
  );
}

createPlannedLaborCost.PATH = '/v0/plannedLaborCosts/{id}';
